import { Button, TextField } from "@mui/material";
import LoadingSpinner from "components/LoadingSpinner";
import React from "react";
import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";
import SubmitButton from "components/Button/SubmitButton";
import { missingPatientDetailValidationSchema } from "schemas/missingPatientDetailValidationSchema";
import { Formik } from "formik";
import { showErrorToast } from "utils/toast";
import { useSelector } from "react-redux";
import { getBatteryLife } from "utils/report";

const MissingPatientDetailModal = ({
  showModal,
  onClose,
  isLoading,
  handleReportNote,
  notes,
}) => {
  const { billableDate } = useSelector((state) => state.transmission);

  const handleMissingInformation = async (isProceed, values) => {
    try {
      if (values?.battery) {
        const reportNotes = Array.isArray(notes) ? [...notes] : [];
        const noteIndex = reportNotes.findIndex(
          (item) => item?.note === "Battery"
        );

        let batteryContentItem = {
          alert: "None",
          description: values.battery,
          pageNumber: null,
        };

        if (noteIndex !== -1) {
          batteryContentItem.alert =
            reportNotes[noteIndex]?.content?.[0]?.alert || "None";

          reportNotes[noteIndex] = {
            ...reportNotes[noteIndex],
            content: [batteryContentItem],
          };
        } else {
          // No Battery note → create a new one
          const newBatteryNote = {
            note: "Battery",
            placeholders: [],
            content: [batteryContentItem],
          };

          reportNotes.push(newBatteryNote);
        }

        const reportNoteProps = {
          notes: { reportNotes },
          billingDate: billableDate,
          isProcessAction: isProceed,
          shouldSendLetter: true,
        };

        handleReportNote(reportNoteProps);
        handleClose();
      }
    } catch (error) {
      showErrorToast(error || error?.message);
    }
  };

  const handleClose = async () => {
    onClose();
    await handleMissingInformation(false);
  };

  return (
    <ModalWrapper
      title="Confirm Patient Details"
      show={showModal}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
    >
      <div>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <Formik
            initialValues={{
              battery: getBatteryLife(notes) || "",
            }}
            validationSchema={missingPatientDetailValidationSchema}
            onSubmit={(values) => handleMissingInformation(true, values)}
            enableReinitialize
          >
            {({ values, errors, touched, handleChange, handleSubmit }) => (
              <div className="d-flex flex-column g-1">
                <p className="mt-2 mb-2">
                  Please review the following required information to generate
                  this patient’s scheduled letter, and provide or update the
                  fields as needed before proceeding
                </p>
                <TextField
                  fullWidth
                  required
                  label="Battery Life"
                  name="battery"
                  value={values.battery}
                  error={touched.battery && errors.battery}
                  helperText={errors.battery}
                  onChange={handleChange}
                />

                <div className="d-flex justify-end g-1">
                  <Button
                    variant="outlined"
                    color="secondary"
                    type="button"
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>

                  <SubmitButton
                    buttonText="Save & Process"
                    handleClick={handleSubmit}
                  />
                </div>
              </div>
            )}
          </Formik>
        )}
      </div>
    </ModalWrapper>
  );
};

export default MissingPatientDetailModal;
